import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { updateProductDescription } from '../api'
import { keys } from '../queryKeys'

const useUpdateProductDescriptionMutation = () => {
  const queryClient = useQueryClient()
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useMutation(updateProductDescription, {
    onSuccess: (_data, variables) => {
      successToast('Product description updated successfully.')
      queryClient.invalidateQueries(
        keys.categoryProducts({
          accountId,
          region: variables.region,
          catalogId: variables.catalogId,
          categoryId: variables.categoryId,
        })
      )
    },
    onError: () => {
      errorToast('Failed to update product description. Please try again.')
    },
  })
}

export default useUpdateProductDescriptionMutation
